export var ActionAreaInclude = {
    solutions: true,
    image: true,
};
export var ActionAreaWithEmoji = {
    actionArea: {
        select: {
            emoji: true,
            name: true,
        },
    },
};
//# sourceMappingURL=ActionArea.js.map